import api from '@/api/admin'

const state = {
  versions: {
    current: -1,
    available: -1
  }
}

// getters
const getters = {
  versions: state => state.versions
}

// actions
const actions = {
  dbVersions ({ commit }) {
    commit('setDbVersions', null)
    return api.dbVersions().then(
      (response) => {
        if (response.data.err == null) {
          commit('setDbVersions', response.data)
        }
      })
  },

  upgradeDb ({ dispatch }, request) {
    return api.upgradeDb(request).then(
      (response) => {
        if (response.data.err == null) {
          dispatch('dbVersions')
        }
        return response
      }
    )
  },

  runScript ({ dispatch }, request) {
    return api.runScript(request)
  }
}

// mutations
const mutations = {
  setDbVersions (state, versions) {
    if (versions == null) {
      state.versions.current = -1
      state.versions.available = -1
    } else {
      state.versions.current = versions.db
      state.versions.available = versions.s
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
